import { useEffect, useState } from "react";
import { useWatches } from "../../../context/watchProvider";
import { collection, getDocs, limit, query, where } from "firebase/firestore";
import { db } from "../../../firebase";
import LoadingBalls from "../../core/loadingBalls";
import Bannerzin from "../../core/bannerzin";
import { useNavigate } from "react-router-dom";

export default function BrandsGrid({ isMobile }: { isMobile: boolean }) {

    const { top10, getBrands } = useWatches();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [brands, setBrands] = useState<{ brand: string; count: number; }[]>([]);
    const [selectedBrand, setSelectedBrand] = useState<string | null>(null);
    const [brandWatches, setBrandWatches] = useState<{ id: string, slug: string; }[]>([]);
    const [bannerBrandWatches, setBannerBrandWatches] = useState<{ id: string, slug: string; }[]>([]);

    useEffect(() => {
        doGetBrands();
        // eslint-disable-next-line
    }, [top10]);

    useEffect(() => {
        getBrandWatches();
        // eslint-disable-next-line
    }, [selectedBrand]);


    const doGetBrands = async () => {
        try {
            setLoading(true);
            if (!top10?.length) {
                setLoading(false);
                return null;
            }
            const brandzadas = await getBrands();
            setBrands(brandzadas || []);
            if (brandzadas && brandzadas.length > 0) {
                setSelectedBrand(brandzadas[0].brand);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const getBrandWatches = async () => {
        try {
            if (!selectedBrand) {
                return null;
            }
            setLoading(true);
            const watches = await getDocs(query(collection(db, "watches"), where("brand", "==", selectedBrand), where("status", "==", "display"), limit(20)));
            if (watches.empty) {
                setBannerBrandWatches([]);
                setBrandWatches([]);
                setLoading(false);
                return null;
            }
            const brandebuks = watches.docs.map(doc => ({
                id: doc.id,
                status: doc.data().status,
                brand: doc.data().brand,
                model: doc.data().model,
                year: doc.data().year,
                price: doc.data().price,
                slug: doc.data().slug,
                images: doc.data().images,
                createdAt: doc.data().createdAt,
                isBanner: doc.data().isBanner
            }));
            setBannerBrandWatches(brandebuks.filter(b => b.isBanner))
            setBrandWatches(brandebuks.filter(b => !b.isBanner));
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    return (
        <section className="bg-surface py-24 px-4 overflow-hidden border-b border-primary/5">
            <div className="max-w-7xl mx-auto">
                <div className="flex flex-col items-center mb-16">
                    <p className="text-secondary font-bold tracking-[0.4em] text-[10px] uppercase mb-4">Explorar Marcas</p>
                    <h2 className="text-3xl md:text-4xl font-black text-primary tracking-widest uppercase text-center mb-6">
                        Marcas mais acessadas
                    </h2>
                    <div className="w-16 h-1 bg-secondary mb-12" />

                    <div className="flex flex-wrap justify-center gap-3 md:gap-4">
                        {
                            brands.map((b, i) => (
                                <button
                                    key={i}
                                    onClick={() => setSelectedBrand(b.brand)}
                                    className={`px-8 py-3 rounded-full text-xs font-black tracking-widest transition-all duration-300 border-2 ${b.brand === selectedBrand
                                        ? "bg-primary border-primary text-secondary shadow-lg shadow-primary/20 scale-105"
                                        : "bg-white border-primary/5 text-mono hover:border-secondary hover:text-secondary"
                                        }`}
                                >
                                    {b.brand.toUpperCase()}
                                </button>
                            ))
                        }
                    </div>
                </div>

                {
                    loading ?
                        <div className="h-[400px] flex items-center justify-center">
                            <LoadingBalls />
                        </div>
                        :
                        <div className="relative">
                            <div className="flex gap-6 overflow-x-auto pb-8 snap-x no-scrollbar">
                                {
                                    bannerBrandWatches.map((w, i) => (
                                        <div key={`banner-${i}`} className="snap-center">
                                            <Bannerzin sponsor banner={w} onClick={() => navigate(`watches/${w.slug}`)} overlay={false} />
                                        </div>
                                    ))
                                }
                                {
                                    brandWatches.map((w, i) => (
                                        <div key={`watch-${i}`} className="snap-center">
                                            <Bannerzin banner={w} onClick={() => navigate(`watches/${w.slug}`)} overlay={false} />
                                        </div>
                                    ))
                                }
                            </div>

                            {/* Visual Hint for Scrolling */}
                            <div className="absolute right-0 top-1/2 -translate-y-1/2 w-20 h-full bg-gradient-to-l from-surface to-transparent pointer-events-none opacity-60" />
                        </div>
                }
            </div>
        </section>
    )
}
